export default {
    namespaced: true,
    state: {
        purposes: [],
        errors: {
            getPurposes: ''
        }
    },
    getters: {
        getPurposesByType: state => id => {
            if (!id) return state.purposes
            return state.purposes.filter(
                item => item.TypeID == id || item.TypeID === null
            )
        }
    },
    mutations: {
        SET_PURPOSES(state, payload) {
            state.purposes = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getPurposes({ commit }) {
            commit('SET_ERRORS', {
                key: 'getPurposes',
                val: ''
            })

            const url = '/public/dict/purposes'

            try {
                const resp = await this.$axios.get(url).then(res => {
                    return res.data
                })

                commit('SET_PURPOSES', resp)
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getPurposes',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getPurposes',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
